import {
  __commonJS,
  __toESM
} from "./chunk-DELDZXUX.mjs";

// ../../node_modules/.pnpm/strict-uri-encode@2.0.0/node_modules/strict-uri-encode/index.js
var require_strict_uri_encode = __commonJS({
  "../../node_modules/.pnpm/strict-uri-encode@2.0.0/node_modules/strict-uri-encode/index.js"(exports, module) {
    "use strict";
    module.exports = (str) => encodeURIComponent(str).replace(/[!'()*]/g, (x) => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);
  }
});

// ../../node_modules/.pnpm/decode-uri-component@0.2.2/node_modules/decode-uri-component/index.js
var require_decode_uri_component = __commonJS({
  "../../node_modules/.pnpm/decode-uri-component@0.2.2/node_modules/decode-uri-component/index.js"(exports, module) {
    "use strict";
    var token = "%[a-f0-9]{2}";
    var singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi");
    var multiMatcher = new RegExp("(" + token + ")+", "gi");
    function decodeComponents(components, split) {
      try {
        return [decodeURIComponent(components.join(""))];
      } catch (err) {
      }
      if (components.length === 1) {
        return components;
      }
      split = split || 1;
      var left = components.slice(0, split);
      var right = components.slice(split);
      return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
    }
    function decode(input) {
      try {
        return decodeURIComponent(input);
      } catch (err) {
        var tokens = input.match(singleMatcher) || [];
        for (var i = 1; i < tokens.length; i++) {
          input = decodeComponents(tokens, i).join("");
          tokens = input.match(singleMatcher) || [];
        }
        return input;
      }
    }
    function customDecodeURIComponent(input) {
      var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
      };
      var match = multiMatcher.exec(input);
      while (match) {
        try {
          replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
          var result = decode(match[0]);
          if (result !== match[0]) {
            replaceMap[match[0]] = result;
          }
        }
        match = multiMatcher.exec(input);
      }
      replaceMap["%C2"] = "\uFFFD";
      var entries = Object.keys(replaceMap);
      for (var i = 0; i < entries.length; i++) {
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
      }
      return input;
    }
    module.exports = function(encodedURI) {
      if (typeof encodedURI !== "string") {
        throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
      }
      try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        return decodeURIComponent(encodedURI);
      } catch (err) {
        return customDecodeURIComponent(encodedURI);
      }
    };
  }
});

// ../../node_modules/.pnpm/split-on-first@1.1.0/node_modules/split-on-first/index.js
var require_split_on_first = __commonJS({
  "../../node_modules/.pnpm/split-on-first@1.1.0/node_modules/split-on-first/index.js"(exports, module) {
    "use strict";
    module.exports = (string, separator) => {
      if (!(typeof string === "string" && typeof separator === "string")) {
        throw new TypeError("Expected the arguments to be of type `string`");
      }
      if (separator === "") {
        return [string];
      }
      const separatorIndex = string.indexOf(separator);
      if (separatorIndex === -1) {
        return [string];
      }
      return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
      ];
    };
  }
});

// ../../node_modules/.pnpm/filter-obj@1.1.0/node_modules/filter-obj/index.js
var require_filter_obj = __commonJS({
  "../../node_modules/.pnpm/filter-obj@1.1.0/node_modules/filter-obj/index.js"(exports, module) {
    "use strict";
    module.exports = function(obj, predicate) {
      var ret = {};
      var keys = Object.keys(obj);
      var isArr = Array.isArray(predicate);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
          ret[key] = val;
        }
      }
      return ret;
    };
  }
});

// ../../node_modules/.pnpm/query-string@7.1.3/node_modules/query-string/index.js
var require_query_string = __commonJS({
  "../../node_modules/.pnpm/query-string@7.1.3/node_modules/query-string/index.js"(exports) {
    "use strict";
    var strictUriEncode = require_strict_uri_encode();
    var decodeComponent = require_decode_uri_component();
    var splitOnFirst = require_split_on_first();
    var filterObject = require_filter_obj();
    var isNullOrUndefined = (value) => value === null || value === void 0;
    var encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
    function encoderForArrayFormat(options) {
      switch (options.arrayFormat) {
        case "index":
          return (key) => (result, value) => {
            const index = result.length;
            if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
              return result;
            }
            if (value === null) {
              return [...result, [encode(key, options), "[", index, "]"].join("")];
            }
            return [
              ...result,
              [encode(key, options), "[", encode(index, options), "]=", encode(value, options)].join("")
            ];
          };
        case "bracket":
          return (key) => (result, value) => {
            if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
              return result;
            }
            if (value === null) {
              return [...result, [encode(key, options), "[]"].join("")];
            }
            return [...result, [encode(key, options), "[]=", encode(value, options)].join("")];
          };
        case "colon-list-separator":
          return (key) => (result, value) => {
            if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
              return result;
            }
            if (value === null) {
              return [...result, [encode(key, options), ":list="].join("")];
            }
            return [...result, [encode(key, options), ":list=", encode(value, options)].join("")];
          };
        case "comma":
        case "separator":
        case "bracket-separator": {
          const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
          return (key) => (result, value) => {
            if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
              return result;
            }
            value = value === null ? "" : value;
            if (result.length === 0) {
              return [[encode(key, options), keyValueSep, encode(value, options)].join("")];
            }
            return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
          };
        }
        default:
          return (key) => (result, value) => {
            if (value === void 0 || options.skipNull && value === null || options.skipEmptyString && value === "") {
              return result;
            }
            if (value === null) {
              return [...result, encode(key, options)];
            }
            return [...result, [encode(key, options), "=", encode(value, options)].join("")];
          };
      }
    }
    function parserForArrayFormat(options) {
      let result;
      switch (options.arrayFormat) {
        case "index":
          return (key, value, accumulator) => {
            result = /\[(\d*)\]$/.exec(key);
            key = key.replace(/\[\d*\]$/, "");
            if (!result) {
              accumulator[key] = value;
              return;
            }
            if (accumulator[key] === void 0) {
              accumulator[key] = {};
            }
            accumulator[key][result[1]] = value;
          };
        case "bracket":
          return (key, value, accumulator) => {
            result = /(\[\])$/.exec(key);
            key = key.replace(/\[\]$/, "");
            if (!result) {
              accumulator[key] = value;
              return;
            }
            if (accumulator[key] === void 0) {
              accumulator[key] = [value];
              return;
            }
            accumulator[key] = [].concat(accumulator[key], value);
          };
        case "colon-list-separator":
          return (key, value, accumulator) => {
            result = /(:list)$/.exec(key);
            key = key.replace(/:list$/, "");
            if (!result) {
              accumulator[key] = value;
              return;
            }
            if (accumulator[key] === void 0) {
              accumulator[key] = [value];
              return;
            }
            accumulator[key] = [].concat(accumulator[key], value);
          };
        case "comma":
        case "separator":
          return (key, value, accumulator) => {
            const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
            const isEncodedArray = typeof value === "string" && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
            value = isEncodedArray ? decode(value, options) : value;
            const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item) => decode(item, options)) : value === null ? value : decode(value, options);
            accumulator[key] = newValue;
          };
        case "bracket-separator":
          return (key, value, accumulator) => {
            const isArray = /(\[\])$/.test(key);
            key = key.replace(/\[\]$/, "");
            if (!isArray) {
              accumulator[key] = value ? decode(value, options) : value;
              return;
            }
            const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item) => decode(item, options));
            if (accumulator[key] === void 0) {
              accumulator[key] = arrayValue;
              return;
            }
            accumulator[key] = [].concat(accumulator[key], arrayValue);
          };
        default:
          return (key, value, accumulator) => {
            if (accumulator[key] === void 0) {
              accumulator[key] = value;
              return;
            }
            accumulator[key] = [].concat(accumulator[key], value);
          };
      }
    }
    function validateArrayFormatSeparator(value) {
      if (typeof value !== "string" || value.length !== 1) {
        throw new TypeError("arrayFormatSeparator must be single character string");
      }
    }
    function encode(value, options) {
      if (options.encode) {
        return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
      }
      return value;
    }
    function decode(value, options) {
      if (options.decode) {
        return decodeComponent(value);
      }
      return value;
    }
    function keysSorter(input) {
      if (Array.isArray(input)) {
        return input.sort();
      }
      if (typeof input === "object") {
        return keysSorter(Object.keys(input)).sort((a, b) => Number(a) - Number(b)).map((key) => input[key]);
      }
      return input;
    }
    function removeHash(input) {
      const hashStart = input.indexOf("#");
      if (hashStart !== -1) {
        input = input.slice(0, hashStart);
      }
      return input;
    }
    function getHash(url) {
      let hash = "";
      const hashStart = url.indexOf("#");
      if (hashStart !== -1) {
        hash = url.slice(hashStart);
      }
      return hash;
    }
    function extract(input) {
      input = removeHash(input);
      const queryStart = input.indexOf("?");
      if (queryStart === -1) {
        return "";
      }
      return input.slice(queryStart + 1);
    }
    function parseValue(value, options) {
      if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === "string" && value.trim() !== "")) {
        value = Number(value);
      } else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) {
        value = value.toLowerCase() === "true";
      }
      return value;
    }
    function parse(query, options) {
      options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
      }, options);
      validateArrayFormatSeparator(options.arrayFormatSeparator);
      const formatter = parserForArrayFormat(options);
      const ret = /* @__PURE__ */ Object.create(null);
      if (typeof query !== "string") {
        return ret;
      }
      query = query.trim().replace(/^[?#&]/, "");
      if (!query) {
        return ret;
      }
      for (const param of query.split("&")) {
        if (param === "") {
          continue;
        }
        let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, " ") : param, "=");
        value = value === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, ret);
      }
      for (const key of Object.keys(ret)) {
        const value = ret[key];
        if (typeof value === "object" && value !== null) {
          for (const k of Object.keys(value)) {
            value[k] = parseValue(value[k], options);
          }
        } else {
          ret[key] = parseValue(value, options);
        }
      }
      if (options.sort === false) {
        return ret;
      }
      return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) {
          result[key] = keysSorter(value);
        } else {
          result[key] = value;
        }
        return result;
      }, /* @__PURE__ */ Object.create(null));
    }
    exports.extract = extract;
    exports.parse = parse;
    exports.stringify = (object, options) => {
      if (!object) {
        return "";
      }
      options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
      }, options);
      validateArrayFormatSeparator(options.arrayFormatSeparator);
      const shouldFilter = (key) => options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
      const formatter = encoderForArrayFormat(options);
      const objectCopy = {};
      for (const key of Object.keys(object)) {
        if (!shouldFilter(key)) {
          objectCopy[key] = object[key];
        }
      }
      const keys = Object.keys(objectCopy);
      if (options.sort !== false) {
        keys.sort(options.sort);
      }
      return keys.map((key) => {
        const value = object[key];
        if (value === void 0) {
          return "";
        }
        if (value === null) {
          return encode(key, options);
        }
        if (Array.isArray(value)) {
          if (value.length === 0 && options.arrayFormat === "bracket-separator") {
            return encode(key, options) + "[]";
          }
          return value.reduce(formatter(key), []).join("&");
        }
        return encode(key, options) + "=" + encode(value, options);
      }).filter((x) => x.length > 0).join("&");
    };
    exports.parseUrl = (url, options) => {
      options = Object.assign({
        decode: true
      }, options);
      const [url_, hash] = splitOnFirst(url, "#");
      return Object.assign(
        {
          url: url_.split("?")[0] || "",
          query: parse(extract(url), options)
        },
        options && options.parseFragmentIdentifier && hash ? { fragmentIdentifier: decode(hash, options) } : {}
      );
    };
    exports.stringifyUrl = (object, options) => {
      options = Object.assign({
        encode: true,
        strict: true,
        [encodeFragmentIdentifier]: true
      }, options);
      const url = removeHash(object.url).split("?")[0] || "";
      const queryFromUrl = exports.extract(object.url);
      const parsedQueryFromUrl = exports.parse(queryFromUrl, { sort: false });
      const query = Object.assign(parsedQueryFromUrl, object.query);
      let queryString = exports.stringify(query, options);
      if (queryString) {
        queryString = `?${queryString}`;
      }
      let hash = getHash(object.url);
      if (object.fragmentIdentifier) {
        hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
      }
      return `${url}${queryString}${hash}`;
    };
    exports.pick = (input, filter, options) => {
      options = Object.assign({
        parseFragmentIdentifier: true,
        [encodeFragmentIdentifier]: false
      }, options);
      const { url, query, fragmentIdentifier } = exports.parseUrl(input, options);
      return exports.stringifyUrl({
        url,
        query: filterObject(query, filter),
        fragmentIdentifier
      }, options);
    };
    exports.exclude = (input, filter, options) => {
      const exclusionFilter = Array.isArray(filter) ? (key) => !filter.includes(key) : (key, value) => !filter(key, value);
      return exports.pick(input, exclusionFilter, options);
    };
  }
});

// src/emails.ts
var EMAILS = {
  ORDERS: process.env.ORDERS_EMAIL_ADDRESS || process.env.NEXT_PUBLIC_ORDERS_EMAIL_ADDRESS,
  SALES: process.env.SALES_EMAIL_ADDRESS || process.env.NEXT_PUBLIC_SALES_EMAIL_ADDRESS,
  CUSTOMER_SUPPORT: process.env.CUSTOMER_SUPPORT_EMAIL_ADDRESS || process.env.NEXT_PUBLIC_CUSTOMER_SUPPORT_EMAIL_ADDRESS,
  EXPERT_SUPPORT: process.env.EXPERT_SUPPORT_EMAIL_ADDRESS || process.env.NEXT_PUBLIC_EXPERT_SUPPORT_EMAIL_ADDRESS,
  SHOWROOM_SUPPORT: process.env.SHOWROOM_SUPPORT_EMAIL_ADDRESS || process.env.NEXT_PUBLIC_SHOWROOM_SUPPORT_EMAIL_ADDRESS,
  CONSULTATIONS_SUPPORT: process.env.CONSULTATIONS_SUPPORT_EMAIL_ADDRESS || process.env.NEXT_PUBLIC_CONSULTATIONS_SUPPORT_EMAIL_ADDRESS,
  TRADE_SUPPORT: process.env.TRADE_SUPPORT_EMAIL_ADDRESS || process.env.NEXT_PUBLIC_TRADE_SUPPORT_EMAIL_ADDRESS
};

// src/revenue.ts
var REVENUE_AREA = {
  CONSULTATIONS: "consultations",
  PROCUREMENT: "procurement",
  SHOWROOM: "showroom",
  GIFT_CARDS: "gift_card"
};

// src/routes.ts
var import_query_string = __toESM(require_query_string());
var withSearchParams = (params = {}) => {
  const paramsString = (0, import_query_string.stringify)(params);
  if (paramsString === "") {
    return "";
  }
  return `?${paramsString}`;
};
var withAnchor = (anchor) => anchor && anchor !== "" ? `#${anchor}` : "";
var withOrderDetailAnchor = (orderId, isCustomPurchase) => {
  if (!orderId) {
    return "";
  }
  if (isCustomPurchase) {
    return `#Purchase-${orderId}`;
  }
  return `#Order-${orderId}`;
};
var ROUTE = {
  // public routes
  STATIC_PAGE: ({ slug }) => `/${slug}`,
  FRONT_PAGE: () => "/",
  FRONT_PAGE_FEATURED: () => "/#featuredExperts",
  CLIENT_VERIFY_EMAIL: () => `/verify-email`,
  SIGN_IN: ({
    returnUrl,
    fromUrl,
    type
  } = {}) => `/sign-in${withSearchParams({ returnUrl, fromUrl, type })}`,
  SIGN_UP: ({
    fromUrl,
    returnUrl
  } = {}) => `/sign-up${withSearchParams({ fromUrl, returnUrl })}`,
  CLIENT_SESSION_REVIEW: ({
    reviewToken
  } = {}) => `/session-review/${reviewToken}`,
  RESET_PASSWORD: ({
    resetPasswordToken
  } = {}) => `/reset-password${withSearchParams({ resetPasswordToken })}`,
  TERMS_OF_USE: () => "/terms",
  PRIVACY_POLICY: () => "/privacy",
  CAREERS: ({ anchor } = {}) => `/careers${withAnchor(anchor)}`,
  FAQ: ({ anchor } = {}) => `/faq${withAnchor(anchor)}`,
  DOCS: () => "/docs",
  SUPPORT: () => "/support",
  SUBSCRIBE: () => "/subscribe",
  EXPERTS: (params = {}) => `/consultations/find-an-expert${withSearchParams(params)}`,
  EXPERT_CONFIRM_EMAIL: () => "/expert-confirm-email",
  CLIENT_CONFIRM_EMAIL: () => "/client-confirm-email",
  QUESTIONNAIRE: ({
    sessionClientId
  } = {}) => `/questionnaire${sessionClientId ? `/${sessionClientId}` : ""}`,
  SESSION_CHECKOUT: ({
    date,
    expertSessionId
  } = {}) => `/session-checkout${expertSessionId ? `/${expertSessionId}` : ""}${date ? `/${date}` : ""}`,
  PURCHASE_CHECKOUT: ({ purchaseId } = {}) => `/purchase/checkout${purchaseId ? `/${purchaseId}` : ""}`,
  PURCHASE_CHECKOUT_THANK_YOU_PAGE: () => `/purchase/checkout/thank-you`,
  COUPON_CHECKOUT: () => `/coupon/checkout`,
  COUPON_CHECKOUT_THANK_YOU_PAGE: () => `/coupon/checkout/thank-you`,
  BLOG_LIST: () => `/blog`,
  BLOG_DETAIL: ({ slug }) => `/blog/${slug}`,
  BLOG_DETAIL_PREVIEW: ({ slug }) => `/blog/preview/${slug}`,
  SESSION_REPORT: ({ id }) => `/consultation-recap/${id}`,
  TRADE: () => "/trade",
  TRADE_CONFIRMATION: ({
    tradeApplicationId
  } = {}) => `/trade/confirmation${withSearchParams({ tradeApplicationId })}`,
  EXPERT_CONTRACT: () => "/expert-agreement",
  REBUILD_HOTLINE: () => "/rebuild-hotline",
  // shop routes
  SHOWROOM: () => "/shop",
  SHOWROOM_THE_EXPERT_VINTAGE: () => "/shop/the-expert-vintage",
  SHOWROOM_CART: () => "/shop/cart",
  SHOWROOM_CHECKOUT: ({ anchor } = {}) => `/shop/checkout${withAnchor(anchor)}`,
  SHOWROOM_CHECKOUT_CONTACT: () => "/shop/checkout/contact",
  SHOWROOM_CHECKOUT_SHIPPING: () => "/shop/checkout/shipping",
  SHOWROOM_DETAIL: ({ slug }) => `/shop/${slug}`,
  SHOWROOM_DETAIL_PREVIEW: ({ slug }) => `/shop/preview/${slug}`,
  SHOWROOM_BRANDS: () => "/shop/brands",
  SHOWROOM_BRAND_DETAIL: ({ slug }) => `/shop/brands/${slug}`,
  SHOWROOM_PRODUCTS: (params = {}) => `/shop/products${withSearchParams(params)}`,
  SHOWROOM_CATEGORY: () => "/shop/category",
  SHOWROOM_PRODUCT_DETAIL: ({
    pageSlug = "products",
    slug,
    variantSlug = "",
    ...rest
  }) => `/shop/${pageSlug}/${slug}${variantSlug ? `/${variantSlug}` : ""}${withSearchParams(rest)}`,
  SHOWROOM_PRODUCT_DETAIL_PREVIEW: ({
    slug,
    variantSlug = "",
    ...rest
  }) => `/shop/products/preview/${slug}${variantSlug ? `/${variantSlug}` : ""}${withSearchParams(rest)}`,
  SHOWROOM_COLLECTION_PRODUCT_DETAIL: ({
    slug,
    pid,
    variantSlug = "",
    ...rest
  }) => `/shop/${slug}/${pid}${variantSlug ? `/${variantSlug}` : ""}${withSearchParams(rest)}`,
  SHOWROOM_COLLECTION_PRODUCT_DETAIL_PREVIEW: ({
    slug,
    pid,
    variantSlug = "",
    ...rest
  }) => `/shop/${slug}/preview/${pid}${variantSlug ? `/${variantSlug}` : ""}${withSearchParams(rest)}`,
  ORDER_CONFIRMATION: ({
    orderId,
    productId,
    shareaSaleToken
  } = {}) => `/shop/confirmation${withSearchParams({ orderId, productId, shareaSaleToken })}`,
  SHOWROOM_VIP_ACCESS: () => "/shop/vip-access",
  // client routes
  CLIENT: ({ sessionId } = {}) => `/client${withSearchParams({ consultation: sessionId })}`,
  CLIENT_SESSIONS_PAST: () => "/client/past",
  CLIENT_SETTINGS_ACCOUNT: () => "/client/account",
  CLIENT_SETTINGS_PASSWORD: () => "/client/password",
  CLIENT_SETTINGS_PAYMENT: () => "/client/payment",
  CLIENT_SETTINGS_ADDRESSES: () => "/client/addresses",
  CLIENT_SETTINGS_INVOICES: () => "/client/invoices",
  CLIENT_FAVORITE_EXPERTS: () => "/client/favorite-experts",
  CLIENT_PURCHASES: ({
    orderId,
    isCustomPurchase
  } = {}) => `/client/purchases${withOrderDetailAnchor(orderId, isCustomPurchase)}`,
  // expert routes
  EXPERT_DASHBOARD: () => "/expert",
  EXPERT_PURCHASES: ({ anchor } = {}) => `/expert/purchases${withAnchor(anchor)}`,
  EXPERT_COMMISSIONS: ({ anchor } = {}) => `/expert/commissions${withAnchor(anchor)}`,
  EXPERT_ORDERS: ({
    orderId,
    isCustomPurchase
  } = {}) => `/expert/orders${withOrderDetailAnchor(orderId, isCustomPurchase)}`,
  EXPERT_SESSIONS: () => "/expert/consultations",
  EXPERT_SESSIONS_PRIVATE_FORM: ({
    expertSessionId
  }) => `/expert/private/${expertSessionId}`,
  EXPERT_SESSIONS_GROUP_FORM: ({
    expertSessionId
  }) => `/expert/group/${expertSessionId}`,
  // don't forget to add conflicting expert routes with slug also
  // to constant ALREADY_USED_ROUTES in api/src/constants.js
  EXPERT_SIGN_IN: ({
    returnUrl,
    fromUrl
  } = {}) => `/sign-in${withSearchParams({ returnUrl, fromUrl, type: "expert" })}`,
  TRADE_SIGN_IN: ({
    returnUrl,
    fromUrl
  } = {}) => `/sign-in${withSearchParams({ returnUrl, fromUrl, type: "trade" })}`,
  EXPERT_PROFILE: ({ slug, ...rest } = {}) => `/expert/${slug}${withSearchParams(rest)}`,
  EXPERT_CATEGORIES: () => "/expert/categories",
  EXPERT_CALENDAR_PAST: ({ sessionId } = {}) => `/expert/past${withSearchParams({ consultation: sessionId })}`,
  EXPERT_CALENDAR_UPCOMING: ({
    sessionId,
    date
  } = {}) => `/expert/upcoming${withSearchParams({
    consultation: sessionId,
    ...date && { date }
  })}`,
  EXPERT_CALENDAR_AVAILABILITY: () => "/expert/availability",
  EXPERT_CLIENTS: () => "/expert/clients",
  EXPERT_TEAM: () => "/expert/team",
  EXPERT_REFERRAL_PROGRAM: () => "/expert/referral-program",
  EXPERT_SETTINGS_PROFILE: () => "/expert/settings/profile",
  EXPERT_SETTINGS_SHOWROOM: () => "/expert/settings/showroom",
  EXPERT_SETTINGS_ACCOUNT: () => "/expert/settings/account",
  EXPERT_SETTINGS_PAYMENT_OVERVIEW: (params = {}) => `/expert/settings/payment/overview${withSearchParams(params)}`,
  EXPERT_SETTINGS_PAYMENT_BILLING: () => "/expert/settings/payment/billing",
  EXPERT_SETTINGS_TAX_DOCUMENTS: () => "/expert/settings/payment/tax-documents",
  EXPERT_SETTINGS_PASSWORD: () => "/expert/settings/change-password",
  EXPERT_VENDORS: () => "/expert/vendors",
  // admin routes
  // update admin-routes.spec.js test if you change admin routes list
  ADMIN: () => "/admin",
  ADMIN_SIGN_IN: () => "/admin/sign-in",
  ADMIN_CLIENTS: () => "/admin/clients",
  ADMIN_CLIENT_DETAIL: ({ id }) => `/admin/clients/${id}`,
  ADMIN_ADMINS: () => `/admin/admins`,
  ADMIN_CATEGORIES: () => `/admin/categories`,
  ADMIN_EXPERT_APPLICATIONS: () => `/admin/expert-applications`,
  ADMIN_EXPERT_TRADE_APPLICATIONS: () => `/admin/expert-trade-applications`,
  ADMIN_EXPERT_APPLICATION_DETAIL: ({ id }) => `/admin/expert-applications/${id}`,
  ADMIN_EXPERT_TRADE_APPLICATION_DETAIL: ({ id }) => `/admin/expert-trade-applications/${id}`,
  ADMIN_ALL_EXPERT_USERS: () => `/admin/experts/all-members`,
  ADMIN_TRADE_EXPERT_USERS: () => `/admin/experts/trade-members`,
  ADMIN_TRADE_EXPERTS: () => `/admin/experts/trade-firms`,
  ADMIN_EXPERTS: () => `/admin/experts`,
  ADMIN_EXPERT_DETAIL: ({ id }) => `/admin/experts/${id}`,
  ADMIN_FEATURED_EXPERTS: () => `/admin/featured-experts`,
  ADMIN_SESSIONS: () => `/admin/sessions`,
  ADMIN_SESSION_DETAIL: ({ id }) => `/admin/sessions/${id}`,
  ADMIN_SESSION_LOGS: () => `/admin/session-logs`,
  ADMIN_REGIONS: () => `/admin/regions`,
  ADMIN_VENDORS: () => `/admin/vendors`,
  ADMIN_CMS_FAQ: () => `/admin/articles/faq`,
  ADMIN_CMS_LANDING_PAGE: () => `/admin/articles/home`,
  ADMIN_CMS_CAREERS_PAGE: () => `/admin/articles/careers`,
  ADMIN_CMS_TERMS_PAGE: () => `/admin/articles/terms`,
  ADMIN_CMS_BLOG_PAGE: () => `/admin/articles/blog`,
  ADMIN_NEW_CMS_ARTICLE_PAGE: () => `/admin/articles/new`,
  ADMIN_CMS_ARTICLE_PAGE: ({ id }) => `/admin/articles/${id}`,
  ADMIN_CMS_ARTICLES: () => `/admin/articles`,
  ADMIN_CMS_CONSULTATIONS: () => `/admin/consultations`,
  ADMIN_NEW_CMS_CONSULTATION_PAGE: () => `/admin/consultations/new`,
  ADMIN_CMS_CONSULTATION_PAGE: ({ id }) => `/admin/consultations/${id}`,
  ADMIN_CMS_BRANDS: () => `/admin/brands`,
  ADMIN_CMS_BRAND_PAGE: ({ id }) => `/admin/brands/${id}`,
  ADMIN_PURCHASES: () => `/admin/purchases`,
  ADMIN_ORDERS: () => `/admin/orders`,
  ADMIN_NEW_PURCHASE: () => `/admin/purchases/new`,
  ADMIN_PURCHASE_DETAIL: ({ id }) => `/admin/purchases/${id}`,
  ADMIN_PRODUCTS: () => `/admin/products`,
  ADMIN_PRODUCT_DETAIL: ({ id }) => `/admin/products/${id}`,
  ADMIN_PRODUCT_VARIANT_DETAIL: ({
    productId,
    variantId
  }) => `/admin/products/${productId}/${variantId}`,
  ADMIN_MANUAL_COLLECTIONS: () => `/admin/collections/manual-collections`,
  ADMIN_AUTO_COLLECTIONS: () => `/admin/collections/auto-collections`,
  ADMIN_EXPERT_COLLECTIONS: () => `/admin/collections/expert-collections`,
  ADMIN_COLLECTION_DETAIL: ({ id }) => `/admin/collections/${id}`,
  ADMIN_NEW_SHOWROOM_PAGE: () => `/admin/showrooms/new`,
  ADMIN_SHOWROOM_PAGE: ({ id }) => `/admin/showrooms/${id}`,
  ADMIN_SHOWROOMS: () => `/admin/showrooms`,
  ADMIN_CMS_CATEGORY_PAGES: () => `/admin/showrooms/category`,
  ADMIN_CMS_CATEGORY_PAGE_DETAIL: ({ id }) => `/admin/showrooms/category/${id}`,
  ADMIN_SHOWROOM_NAVIGATION: () => "/admin/showroom-navigation",
  ADMIN_SHOWROOM_NAVIGATION_DETAIL: ({ id }) => `/admin/showroom-navigation/${id}`,
  ADMIN_COUPONS: () => "/admin/coupons",
  ADMIN_CHECKOUT_DETAIL: ({ id }) => `/admin/checkouts/${id}`,
  ADMIN_LISTING_WIDGETS: () => `/admin/listing-widgets`,
  ADMIN_LISTING_WIDGET_DETAIL: ({ id }) => `/admin/listing-widgets/${id}`,
  ADMIN_NEW_LISTING_WIDGET: () => `/admin/listing-widgets/new`,
  ADMIN_ORDER_DETAIL: ({ id }) => `/admin/orders/${id}`,
  ADMIN_TRUSTED_SOURCES: () => `/admin/trusted-sources`,
  ADMIN_CMS_BRANDS_LANDING_PAGE: () => `/admin/showroom/brands`,
  ADMIN_TRADE_LICENSES: () => `/admin/trade-licenses`,
  ADMIN_TRADE_LICENSE_DETAIL: ({ id }) => `/admin/trade-licenses/${id}`,
  ADMIN_PRODUCTS_INVENTORY_SYNC: () => `/admin/inventory-sync`,
  ADMIN_PRODUCTS_INVENTORY_SYNC_DETAIL: ({ id }) => `/admin/inventory-sync/${id}`,
  // Consultation routes
  CONSULTATIONS: () => "/consultations",
  CONSULTATIONS_DYNAMIC: ({
    slug,
    isSlugWithConsultationPrefix = false
  }) => `${isSlugWithConsultationPrefix ? "" : "/consultations"}/${slug}`,
  CONSULTATION_PAGE_PREVIEW: ({ slug }) => `/consultations/preview/${slug}/consultations`,
  FIND_AN_EXPERT_TAB_DYNAMIC: ({
    slug,
    tab,
    ...rest
  }) => `/consultations/find-an-expert/${slug}/${tab}${withSearchParams(rest)}`,
  FIND_AN_EXPERT_CONSULTATION_TAB_DYNAMIC: ({
    slug,
    ...rest
  }) => `/consultations/find-an-expert/${slug}/consultations${withSearchParams(
    rest
  )}`,
  FIND_AN_EXPERT_SHOWROOM_TAB_DYNAMIC: ({
    slug,
    ...rest
  }) => `/consultations/find-an-expert/${slug}/showroom${withSearchParams(rest)}`,
  FIND_AN_EXPERT: () => "/consultations/find-an-expert",
  TRADE_PROGRAM_AGREEMENT: () => "/trade-program-agreeement"
};
var DYNAMIC_ROUTE = {
  // client routes
  CLIENT_SESSION_REVIEW: () => "/session-review/[token]",
  CLIENT_SESSION_QUESTIONNAIRE: () => "/questionnaire/[sessionClientId]",
  SESSION_CHECKOUT: () => "/session-checkout/[expertSessionId]/[date]",
  PURCHASE_CHECKOUT: () => "/purchase/checkout/[id]",
  // shop routes
  SHOWROOM_DETAIL: () => "/shop/[slug]",
  SHOWROOM_PRODUCT_DETAIL: () => "/shop/products/[productSlug]/[variantSlug]",
  SHOWROOM_BRAND_PAGE: () => "/shop/brands/[slug]",
  // expert routes
  EXPERT_PROFILE_CONSULTATION_TAB: () => "/consultations/find-an-expert/[slug]/consultations",
  EXPERT_PROFILE_SHOWROOM_TAB: () => "/consultations/find-an-expert/[slug]/showroom",
  EXPERT_SESSIONS_PRIVATE_FORM: () => "/expert/private/[id]",
  EXPERT_SESSIONS_GROUP_FORM: () => "/expert/group/[id]",
  // admin routes
  ADMIN_CLIENT_DETAIL: () => "/admin/clients/[id]",
  ADMIN_EXPERT_APPLICATION_DETAIL: () => "/admin/expert-applications/[id]",
  ADMIN_EXPERT_DETAIL: () => "/admin/experts/[id]",
  ADMIN_SESSION_DETAIL: () => "/admin/sessions/[id]",
  ADMIN_COLLECTION_DETAIL: () => "/admin/collections/[id]",
  ADMIN_LISTING_WIDGET_DETAIL: () => "/admin/listing-widgets/[id]",
  ADMIN_CMS_ARTICLE_PAGE: () => "/admin/articles/[slug]",
  // blog
  BLOG_DETAIL: () => `/blog/[slug]`
};
var PUBLIC_ROUTE = [
  ROUTE.FRONT_PAGE(),
  ROUTE.FRONT_PAGE_FEATURED(),
  ROUTE.SIGN_IN(),
  ROUTE.SIGN_UP(),
  ROUTE.RESET_PASSWORD(),
  ROUTE.TERMS_OF_USE(),
  ROUTE.PRIVACY_POLICY(),
  ROUTE.FAQ(),
  ROUTE.DOCS(),
  ROUTE.SUPPORT(),
  ROUTE.EXPERT_SIGN_IN(),
  DYNAMIC_ROUTE.CLIENT_SESSION_REVIEW(),
  DYNAMIC_ROUTE.EXPERT_PROFILE_CONSULTATION_TAB(),
  DYNAMIC_ROUTE.EXPERT_PROFILE_SHOWROOM_TAB()
];
var RECAPTCHA_ROUTES = [
  ROUTE.SIGN_UP(),
  ROUTE.CLIENT_SETTINGS_ACCOUNT()
];
var REVALIDATE_ROUTE = ({ slug }) => `/api/revalidate/route${withSearchParams({ slug })}`;
var SIGN_IN_EXPERT_TRADE_ROUTES = ["trade", "expert"];

// src/timezones.ts
var DEPRECATED_TIMEZONES_MAPPING = [
  { old: "Australia/ACT", new: "Australia/Sydney" },
  { old: "Australia/LHI", new: "Australia/Lord_Howe" },
  { old: "Australia/North", new: "Australia/Darwin" },
  { old: "Australia/NSW", new: "Australia/Sydney" },
  { old: "Australia/Queensland", new: "Australia/Brisbane" },
  { old: "Australia/South", new: "Australia/Adelaide" },
  { old: "Australia/Tasmania", new: "Australia/Hobart" },
  { old: "Australia/Victoria", new: "Australia/Melbourne" },
  { old: "Australia/West", new: "Australia/Perth" },
  { old: "Brazil/Acre", new: "America/Rio_Branco" },
  { old: "Brazil/DeNoronha", new: "America/Noronha" },
  { old: "Brazil/East", new: "America/Sao_Paulo" },
  { old: "Brazil/West", new: "America/Manaus" },
  { old: "Canada/Atlantic", new: "America/Halifax" },
  { old: "Canada/Central", new: "America/Winnipeg" },
  { old: "Canada/Eastern", new: "America/Toronto" },
  { old: "Canada/Mountain", new: "America/Edmonton" },
  { old: "Canada/Newfoundland", new: "America/St_Johns" },
  { old: "Canada/Pacific", new: "America/Vancouver" },
  { old: "Canada/Saskatchewan", new: "America/Regina" },
  { old: "Canada/Yukon", new: "America/Whitehorse" },
  { old: "CET", new: "Europe/Paris" },
  { old: "Chile/Continental", new: "America/Santiago" },
  { old: "Chile/EasterIsland", new: "Pacific/Easter" },
  { old: "CST6CDT", new: "America/Chicago" },
  { old: "Cuba", new: "America/Havana" },
  { old: "EET", new: "Europe/Sofia" },
  { old: "Egypt", new: "Africa/Cairo" },
  { old: "Eire", new: "Europe/Dublin" },
  { old: "EST", new: "America/Cancun" },
  { old: "EST5EDT", new: "America/New_York" },
  { old: "Etc/Greenwich", new: "Etc/GMT" },
  { old: "Etc/Universal", new: "Etc/UTC" },
  { old: "Etc/Zulu", new: "Etc/UTC" },
  { old: "GB", new: "Europe/London" },
  { old: "GB-Eire", new: "Europe/London" },
  { old: "GMT+0", new: "Etc/GMT" },
  { old: "GMT0", new: "Etc/GMT" },
  { old: "GMT\u22120", new: "Etc/GMT" },
  { old: "Greenwich", new: "Etc/GMT" },
  { old: "Hongkong", new: "Asia/Hong_Kong" },
  { old: "HST", new: "Pacific/Honolulu" },
  { old: "Iceland", new: "Atlantic/Reykjavik" },
  { old: "Iran", new: "Asia/Tehran" },
  { old: "Israel", new: "Asia/Jerusalem" },
  { old: "Jamaica", new: "America/Jamaica" },
  { old: "Japan", new: "Asia/Tokyo" },
  { old: "Kwajalein", new: "Pacific/Kwajalein" },
  { old: "Libya", new: "Africa/Tripoli" },
  { old: "MET", new: "Europe/Paris" },
  { old: "Mexico/BajaNorte", new: "America/Tijuana" },
  { old: "Mexico/BajaSur", new: "America/Mazatlan" },
  { old: "Mexico/General", new: "America/Mexico_City" },
  { old: "MST", new: "America/Phoenix" },
  { old: "MST7MDT", new: "America/Denver" },
  { old: "Navajo", new: "America/Denver" },
  { old: "NZ", new: "Pacific/Auckland" },
  { old: "NZ-CHAT", new: "Pacific/Chatham" },
  { old: "Poland", new: "Europe/Warsaw" },
  { old: "Portugal", new: "Europe/Lisbon" },
  { old: "PRC", new: "Asia/Shanghai" },
  { old: "PST8PDT", new: "America/Los_Angeles" },
  { old: "ROC", new: "Asia/Taipei" },
  { old: "ROK", new: "Asia/Seoul" },
  { old: "Singapore", new: "Asia/Singapore" },
  { old: "Turkey", new: "Europe/Istanbul" },
  { old: "UCT", new: "Etc/UCT" },
  { old: "Universal", new: "Etc/UTC" },
  { old: "US/Alaska", new: "America/Anchorage" },
  { old: "US/Aleutian", new: "America/Adak" },
  { old: "US/Arizona", new: "America/Phoenix" },
  { old: "US/Central", new: "America/Chicago" },
  { old: "US/Eastern", new: "America/New_York" },
  { old: "US/East-Indiana", new: "America/Indiana/Indianapolis" },
  { old: "US/Hawaii", new: "Pacific/Honolulu" },
  { old: "US/Indiana-Starke", new: "America/Indiana/Knox" },
  { old: "US/Michigan", new: "America/Detroit" },
  { old: "US/Mountain", new: "America/Denver" },
  { old: "US/Pacific", new: "America/Los_Angeles" },
  { old: "US/Pacific-New", new: "America/Los_Angeles" },
  { old: "US/Samoa", new: "Pacific/Pago_Pago" },
  { old: "WET", new: "Europe/Lisbon" },
  { old: "W-SU", new: "Europe/Moscow" },
  { old: "Zulu", new: "Etc/UTC" }
];
var additionalTimezones = [
  {
    shortCode: "ET",
    label: "Eastern Time",
    name: "custom/Eastern_Time",
    timezone: "America/New_York",
    includedTimezones: [
      "America/Detroit",
      "America/Indiana/Indianapolis",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Vevay",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/New_York",
      "America/Toronto",
      "America/Montreal"
    ]
  },
  {
    shortCode: "CT",
    label: "Central Time",
    name: "custom/Central_Time",
    timezone: "America/Chicago",
    includedTimezones: [
      "America/Chicago",
      "America/Indiana/Knox",
      "America/Indiana/Tell_City",
      "America/Menominee",
      "America/North_Dakota/Beulah",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/Winnipeg"
    ]
  },
  {
    shortCode: "MT",
    label: "Mountain Time",
    name: "custom/Mountain_Time",
    timezone: "America/Denver",
    includedTimezones: ["America/Boise", "America/Denver", "America/Edmonton"]
  },
  {
    shortCode: "MST",
    label: "Mountain Standard Time - Arizona",
    name: "custom/Arizona",
    timezone: "America/Phoenix",
    includedTimezones: ["America/Phoenix"]
  },
  {
    shortCode: "PT",
    label: "Pacific Time",
    name: "custom/Pacific_Time",
    timezone: "America/Los_Angeles",
    includedTimezones: ["America/Los_Angeles", "America/Vancouver"]
  },
  {
    shortCode: "AKT",
    label: "Alaska Time",
    name: "custom/Alaska_Time",
    timezone: "America/Anchorage",
    includedTimezones: [
      "America/Anchorage",
      "America/Juneau",
      "America/Nome",
      "America/Sitka",
      "America/Yakutat",
      "America/Metlakatla"
    ]
  }
];
var DEPRECATED_TIMEZONES = DEPRECATED_TIMEZONES_MAPPING.map(
  ({ old }) => old
);
var mapCustomizedTimezoneToTimezone = (timezone) => {
  const additionalTimezone = additionalTimezones.find(
    (additionalTimezoneObject) => additionalTimezoneObject.name === timezone
  );
  if (additionalTimezone) {
    return additionalTimezone.timezone;
  }
  return timezone;
};
var mapTimezoneToCustomizedTimezone = (timezone) => {
  const additionalTimezone = additionalTimezones.find(
    ({ includedTimezones }) => includedTimezones.some((zone) => zone === timezone)
  );
  if (additionalTimezone) {
    return additionalTimezone.name;
  }
  return timezone;
};
var formatTimezoneToString = (timezone) => {
  const additionalTimezone = additionalTimezones.find(
    ({ name }) => name === timezone
  );
  return additionalTimezone && additionalTimezone.label || timezone;
};

// src/flx.ts
var FLX_KEY_PREFIX = "the-expert_";
var MANAGED_FLX_CUSTOM_FIELDS = {
  ACCORDION: "accordion",
  ASK_EXPERT: "ask-expert",
  CUSTOM_DIMENSIONS: "custom_dimensions",
  ABOVE_THE_FOLD: "above_the_fold",
  CUSTOM_PRODUCT: "custom_product"
};
var MANAGED_FLX_CUSTOM_CONTENT = {
  ABOVE_THE_FOLD: MANAGED_FLX_CUSTOM_FIELDS.ABOVE_THE_FOLD,
  CUSTOM_PRODUCT_HEADLINE: `${MANAGED_FLX_CUSTOM_FIELDS.CUSTOM_PRODUCT}_headline`,
  CUSTOM_PRODUCT_DESCRIPTION: `${MANAGED_FLX_CUSTOM_FIELDS.CUSTOM_PRODUCT}_description`,
  CUSTOM_DIMENSIONS: MANAGED_FLX_CUSTOM_FIELDS.CUSTOM_DIMENSIONS,
  ACCORDION_SHIPPING: `${MANAGED_FLX_CUSTOM_FIELDS.ACCORDION}_shipping`,
  ACCORDION_CARE: `${MANAGED_FLX_CUSTOM_FIELDS.ACCORDION}_care`,
  ACCORDION_DETAILS: `${MANAGED_FLX_CUSTOM_FIELDS.ACCORDION}_details`,
  ASK_EXPERT_SLUG: `${MANAGED_FLX_CUSTOM_FIELDS.ASK_EXPERT}_slug`,
  ASK_EXPERT_COPY: `${MANAGED_FLX_CUSTOM_FIELDS.ASK_EXPERT}_copy`
};
var MANAGED_FLX_VARIANT_CUSTOM_FIELDS = {
  LEAD_TIME: "lead_time",
  VENDOR_SHIPPING: "vendor_shipping",
  VENDOR_SHIPPING_METHOD: "vendor_shipping_method",
  QUANTITY_UNIT_SINGULAR: "quantity_unit_singular",
  QUANTITY_UNIT_PLURAL: "quantity_unit_plural",
  MINIMUM_QUANTITY: "minimum_quantity",
  ENABLE_COUNTER: "enable_counter",
  ARTA_METHOD: "arta_method",
  ARTA_SERVICES: "arta_services",
  ARTA_PACKAGING: "arta-packaging",
  ARTA_SET_QUANTITY: "arta-set_quantity",
  SET_QUANTITY: "set_quantity",
  ARTA_SUBTYPE: "arta-subtype",
  ACCORDION: "accordion",
  ASK_EXPERT: "ask-expert",
  CUSTOM_DIMENSIONS: "custom_dimensions",
  ABOVE_THE_FOLD: "above_the_fold",
  CUSTOM_PRODUCT: "custom_product",
  WAREHOUSE_ADDRESS_LINE_1: "warehouse_address_line_1",
  WAREHOUSE_ADDRESS_LINE_2: "warehouse_address_line_2",
  WAREHOUSE_CITY: "warehouse_city",
  WAREHOUSE_POSTAL_CODE: "warehouse_postal_code",
  WAREHOUSE_COUNTRY_CODE: "warehouse_country_code",
  WAREHOUSE_STATE_CODE: "warehouse_state_code",
  WAREHOUSE_CONTACT_FIRST_NAME: "warehouse_contact_first_name_1",
  WAREHOUSE_CONTACT_LAST_NAME: "warehouse_contact_last_name_1",
  WAREHOUSE_CONTACT_EMAIL: "warehouse_contact_email_1",
  WAREHOUSE_CONTACT_PHONE_NUMBER: "warehouse_contact_phone_1",
  WAREHOUSE_SECONDARY_CONTACT_FIRST_NAME: "warehouse_contact_first_name_2",
  WAREHOUSE_SECONDARY_CONTACT_LAST_NAME: "warehouse_contact_last_name_2",
  WAREHOUSE_SECONDARY_CONTACT_EMAIL: "warehouse_contact_email_2",
  WAREHOUSE_SECONDARY_CONTACT_PHONE_NUMBER: "warehouse_contact_phone_2",
  ARTA_CARTON_WIDTH: "arta_carton_width",
  ARTA_CARTON_HEIGHT: "arta_carton_height",
  ARTA_CARTON_DEPTH: "arta_carton_depth",
  ARTA_CARTON_WEIGHT: "arta_carton_weight",
  ARTA_CARTON_COUNT: "arta_carton_count",
  CARTON_WIDTH: "carton_width",
  CARTON_HEIGHT: "carton_height",
  CARTON_DEPTH: "carton_depth",
  CARTON_WEIGHT: "carton_weight",
  CARTON_COUNT: "carton_count",
  PROPOSITION_65: "proposition65",
  PROP65_ELIGIBLE: "prop65-eligible",
  ARTA_MAX_SUBSIDY: "arta_max_subsidy",
  ARTA_PERCENT_RETAIL: "arta_percent_retail",
  SHIPMENT_MAX_SUBSIDY: "shipment_max_subsidy",
  SHIPMENT_PERCENT_RETAIL: "shipment_percent_retail",
  QUANTITY_THRESHOLD: "quantity_threshold",
  VENDOR_SHIPPING_FLAT_RATE: "vendor_shipping_flat_rate",
  RETURN_NOT_ELIGIBLE: "return_not_eligible",
  FREIGHT_CLUB_METHOD: "freight_club_method",
  FREIGHT_CLUB_CATEGORY: "freight_club_category",
  INCREMENTAL_SHIPMENT_FROM_COUNT: "incremental_shipment_from_count",
  INCREMENTAL_SHIPMENT_PRICE: "incremental_shipment_price",
  SHIPPING_CARRIER: "shipping_carrier",
  DEPTH: "depth",
  TRADE_PRICE: "trade_price",
  TRADE_COST: "trade_cost",
  LEAD_PRODUCT_IMAGE: "lead_product_image",
  PRODUCT_CAROUSEL: "product_carousel",
  FINISH_HEADER: "finish_header",
  FINISH_SUBHEADER: "finish_subheader",
  FINISH_IMAGE: "finish_image",
  FINISH_DETAILS: "finish_details",
  COLOR_HEADER: "color_header",
  COLOR_SUBHEADER: "color_subheader",
  COLOR_IMAGE: "color_image",
  FABRIC_HEADER: "fabric_header",
  FABRIC_SUBHEADER: "fabric_subheader",
  FABRIC_IMAGE: "fabric_image",
  FABRIC_DETAILS: "fabric_details"
};
var MANAGED_FLX_CUSTOM_FIELDS_VALUES = {
  ARTA_METHOD: {
    PARCEL: "parcel",
    SELECT: "select",
    PREMIUM: "premium",
    SELF_SHIP: "self_ship"
  },
  ARTA_METHOD_PARCEL_TRANSPORT_TYPE: {
    GROUND: "ground",
    NEXT_DAY_AIR: "next_day_air",
    SECOND_DAY_AIR: "second_day_air"
  },
  ARTA_SERVICES: {
    ORIGIN_BUILDING_COI: "origin_building_coi",
    DESTINATION_BUILDING_COI: "destination_building_coi",
    DOUBLE_BLIND_BOLS: "double_blind_bols",
    DESTINATION_UNPACKING: "destination_unpacking",
    ORIGIN_FULL_CONDITION_REPORT: "origin_full_condition_report",
    DESTINATION_FULL_CONDITION_REPORT: "destination_full_condition_report",
    ORIGIN_CONDITION_CHECK: "origin_condition_check",
    DESTINATION_CONDITION_CHECK: "destination_condition_check",
    INSTALLATION: "installation",
    PLACEMENT: "placement",
    ASSEMBLY: "assembly",
    DEINSTALLATION: "deinstallation",
    DEBRIS_DISPOSAL: "debris_disposal",
    DESTINATION_ADDITIONAL_LABOR: "destination_additional_labor",
    SIGNATURE_DELIVERY: "signature_delivery",
    TARMAC_SUPERVISION: "tarmac_supervision"
  },
  ARTA_PACKAGING: {
    ALCOHOL_CASE: "alcohol_case",
    LAY_FLAT_WINE_BOX: "lay_flat_wine_box",
    BLANKET: "blanket",
    WARDROBE_BOX: "wardrobe_box",
    CARDBOARD_BOX: "cardboard_box",
    CHANDELIER_BOX: "chandelier_box",
    CHAIR_BOX: "chair_box",
    CBIN_CLOSED: "cbin_closed",
    CBIN_OPEN: "cbin_open",
    PLY_BOX: "ply_box",
    FINE_ART_ECONO_CRATE: "fine_art_econo_crate",
    FINE_ART_INTERNATIONAL_CRATE: "fine_art_international_crate",
    ECONO_CRATE: "econo_crate",
    INTERNATIONAL_ECONO_CRATE: "international_econo_crate",
    FURNITURE_CRATE: "furniture_crate",
    INTERNATIONAL_FURNITURE_CRATE: "international_furniture_crate",
    PARCEL_CRATE: "parcel_crate",
    MUSEUM_CRATE: "museum_crate",
    INTERNATIONAL_MUSEUM_CRATE: "international_museum_crate",
    FOAM_LINED_BOX: "foam_lined_box",
    CAVITY_BOX: "cavity_box",
    STRONGBOX: "strongbox",
    DOUBLE_BOX: "double_box",
    TRAVEL_FRAME: "travel_frame",
    TRAVEL_FRAME_ART: "travel_frame_art",
    TRAVEL_FRAME_OTHER: "travel_frame_other",
    A_FRAME: "a_frame",
    SLAT_CRATE: "slat_crate",
    TRI_WALL_CRATE: "tri_wall_crate",
    LOCKBOX: "lockbox",
    NO_PACKING: "no_packing",
    PALLET: "pallet",
    INTERNATIONAL_PALLET: "international_pallet",
    PORTFOLIO: "portfolio",
    RUG_ROLLED: "rug_rolled",
    SHADOW_BOX: "shadow_box",
    SLIPCASE: "slipcase",
    SLIPCASE_GLASS_TAPE: "slipcase_glass_tape",
    POLY_CARDBOARD: "poly_cardboard",
    BUBBLE_CARDBOARD: "bubble_cardboard",
    GARMENT_BAG: "garment_bag",
    POLY_ONLY: "poly_only",
    DARTEK_ONLY: "dartek_only",
    BUBBLE_ONLY: "bubble_only",
    CLING_WRAP: "cling_wrap",
    CBIN_COMMUNAL: "cbin_communal",
    SONOTUBE: "sonotube",
    STABILIZING_BOX: "stabilizing_box",
    SHIPPING_TUBE_SMALL: "shipping_tube_small",
    SHIPPING_TUBE_LARGE: "shipping_tube_large"
  },
  ARTA_SUBTYPE: {
    PAINTING_UNFRAMED: "painting_unframed",
    PAINTING_FRAMED: "painting_framed",
    PAINTING_FRAMED_PLEXI: "painting_framed_plexi",
    PAINTING_FRAMED_GLASS: "painting_framed_glass",
    WORK_ON_PAPER_UNFRAMED: "work_on_paper_unframed",
    WORK_ON_PAPER_FRAMED: "work_on_paper_framed",
    WORK_ON_PAPER_FRAMED_PLEXI: "work_on_paper_framed_plexi",
    WORK_ON_PAPER_FRAMED_GLASS: "work_on_paper_framed_glass",
    MIXED_MEDIA_UNFRAMED: "mixed_media_unframed",
    MIXED_MEDIA_FRAMED: "mixed_media_framed",
    MIXED_MEDIA_FRAMED_PLEXI: "mixed_media_framed_plexi",
    MIXED_MEDIA_FRAMED_GLASS: "mixed_media_framed_glass",
    PHOTOGRAPH_UNFRAMED: "photograph_unframed",
    PHOTOGRAPH_FRAMED: "photograph_framed",
    PHOTOGRAPH_FRAMED_PLEXI: "photograph_framed_plexi",
    PHOTOGRAPH_FRAMED_GLASS: "photograph_framed_glass",
    NEW_MEDIA: "new_media",
    SCULPTURE: "sculpture",
    PEDESTAL: "pedestal",
    PEDESTAL_CASE_GLASS: "pedestal_case_glass",
    PEDESTAL_CASE_PLEXI: "pedestal_case_plexi",
    CERAMIC: "ceramic",
    NEON: "neon",
    TAPESTRY: "tapestry",
    OTHER_ART: "other_art",
    TABLE: "table",
    CHAIR: "chair",
    SOFA_LOVESEAT_CHAISE: "sofa_loveseat_chaise",
    FLOOR_LAMP: "floor_lamp",
    FLOOR_LAMP_SHADE: "floor_lamp_shade",
    TABLE_LAMP: "table_lamp",
    TABLE_LAMP_SHADE: "table_lamp_shade",
    SCONCE: "sconce",
    OTTOMAN: "ottoman",
    BOOKCASE_STORAGE: "bookcase_storage",
    NIGHTSTAND: "nightstand",
    ARMOIRE_DRESSER: "armoire_dresser",
    CARPET_RUG: "carpet_rug",
    MIRROR: "mirror",
    CHANDELIER: "chandelier",
    BEDFRAME: "bedframe",
    HEADBOARD: "headboard",
    DESK_VANITY: "desk_vanity",
    MEDIA_CONSOLE: "media_console",
    OTHER_FURNITURE: "other_furniture",
    EARRINGS: "earrings",
    NECKLACE: "necklace",
    BRACELET: "bracelet",
    RING: "ring",
    BROOCH: "brooch",
    WATCH: "watch",
    CUFFLINKS: "cufflinks",
    EYEGLASSES: "eyeglasses",
    SET: "set",
    PRECIOUS_STONES: "precious_stones",
    SNUFF_BOX_CIGARETTE_CASE: "snuff_box_cigarette_case",
    OTHER_JEWELRY: "other_jewelry",
    VASE_VESSEL: "vase_vessel",
    BOWL: "bowl",
    PLAQUE: "plaque",
    OBJECT_OF_VERTU: "object_of_vertu",
    CANDELABRA_CANDLESTICK: "candelabra_candlestick",
    DINNERWARE: "dinnerware",
    FLATWARE: "flatware",
    GLASSWARE: "glassware",
    SERVEWARE: "serveware",
    PORCELAIN_PLATE: "porcelain_plate",
    PORCELAIN_BOWL: "porcelain_bowl",
    TABLETOP_ACCESSORY: "tabletop_accessory",
    CLOCK: "clock",
    OTHER_DECORATIVE_ARTS: "other_decorative_arts",
    STAMP: "stamp",
    BOOK: "book",
    COIN: "coin",
    DOCUMENT_MANUSCRIPT: "document_manuscript",
    TOY: "toy",
    MINIATURE_MODEL: "miniature_model",
    FIGURINE_DOLL: "figurine_doll",
    NEON_SIGN: "neon_sign",
    MEMORABILIA: "memorabilia",
    CAMERA_ELECTRICAL: "camera_electrical",
    OTHER_COLLECTIBLES: "other_collectibles",
    WINE_BOTTLE: "wine_bottle",
    SPIRITS_BOTTLE: "spirits_bottle",
    BEER_BOTTLE: "beer_bottle",
    WINE_CASE: "wine_case",
    SPIRITS_CASE: "spirits_case",
    BEER_CASE: "beer_case",
    WINE_BARREL: "wine_barrel",
    SPIRITS_BARREL: "spirits_barrel",
    BEER_BARREL: "beer_barrel",
    OTHER_ALCOHOLS: "other_alcohols",
    CAR: "car",
    MOTORCYCLE: "motorcycle",
    BUS: "bus",
    VAN: "van",
    LIMOUSINE: "limousine",
    CARRIAGE: "carriage",
    TRAILER: "trailer",
    SIDECAR: "sidecar",
    OTHER_AUTOMOTIVE: "other_automotive",
    CLOTHING: "clothing",
    FOOTWEAR: "footwear",
    HANDBAG: "handbag",
    ACCESSORIES: "accessories",
    OTHER_FASHION: "other_fashion",
    MUSICAL_INSTRUMENT: "musical_instrument",
    FIREARM_WEAPON: "firearm_weapon",
    HUNTING_FISHING: "hunting_fishing",
    MEDICAL_EQUIPMENT: "medical_equipment",
    OTHER: "other"
  },
  FREIGHT_CLUB_METHOD: {
    THRESHOLD: "Threshold",
    WHITE_GLOVE_LIGHT_ASSEMBLY: "WhiteGloveLightAssembly",
    NONE: "None",
    GROUND: "Ground",
    BACK_OF_TRUCK_NO_LIFT_GATE: "BackOfTruckNoLiftGate",
    CURBSIDE_LIFT_GATE: "CurbsideLiftGate",
    ROOM_OF_CHOICE: "RoomOfChoice",
    WHITE_GLOVE_PACKAGING_REMOVAL: "WhiteGlovePackagingRemoval",
    BASIC_THRESHOLD: "BasicThreshold"
  },
  FREIGHT_CLUB_CATEGORY: {
    APPLIANCES: "Appliances",
    CURIO_CABINET: "CurioCabinet",
    ELECTRONICS: "Electronics",
    GLASS: "Glass",
    MATTRESS: "Mattress",
    UPHOLSTERY: "Upholstery",
    VANITY: "Vanity",
    OTHER: "Other",
    CASE_GOODS_FURNITURE: "CasedGoodsFurniture",
    READY_TO_ASSEMBLE_FURNITURE: "ReadyToAssembleFurniture",
    EXERCISE_EQUIPMENT: "ExerciseEquipment",
    IN_HOME_MEDICAL_EQUIPMENT: "InHomeMedicalEquipment",
    GENERAL_COMMODITY: "GeneralCommodity",
    TELEVISIONS: "Televisions",
    NON_BOXED_CYLINDER: "NonBoxedCylinder",
    BOXED_MATTRESS: "BoxedMattress",
    SAFE_VAULT: "SafeVault",
    ARTWORK: "Artwork",
    HAZARDOUS_MATERIAL: "HazardousMaterial"
  }
};
var MANAGED_ARTA_CUSTOM_FIELDS = [
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_METHOD,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_SERVICES,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_PACKAGING,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_SET_QUANTITY,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_SUBTYPE,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_CARTON_WIDTH,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_CARTON_HEIGHT,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_CARTON_DEPTH,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_CARTON_WEIGHT,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_CARTON_COUNT,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_MAX_SUBSIDY,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.ARTA_PERCENT_RETAIL,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.SHIPMENT_MAX_SUBSIDY,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS.SHIPMENT_PERCENT_RETAIL
];
var VENDOR_SHIPPING_NAME = "Standard Shipping";
var ARTA_METHOD_ALIASES = {
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.ARTA_METHOD.PARCEL]: "Standard Shipping",
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.ARTA_METHOD.SELECT]: "White Glove Delivery",
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.ARTA_METHOD.PREMIUM]: "Premium White Glove Delivery",
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.ARTA_METHOD.SELF_SHIP]: "Standard Shipping",
  SELECT_WITHOUT_ADDITIONAL_SERVICES: "Standard Delivery"
};
var FREIGHT_METHOD_ALIASES = {
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.FREIGHT_CLUB_METHOD.GROUND]: "Ground",
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.FREIGHT_CLUB_METHOD.THRESHOLD]: "Standard Shipping",
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.FREIGHT_CLUB_METHOD.WHITE_GLOVE_LIGHT_ASSEMBLY]: "White Glove Delivery"
};
var ARTA_METHOD_PARCEL_TRANSPORT_ESTIMATES = {
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.ARTA_METHOD_PARCEL_TRANSPORT_TYPE.GROUND]: "Delivers in 4-10 business days",
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.ARTA_METHOD_PARCEL_TRANSPORT_TYPE.NEXT_DAY_AIR]: "Delivers in 1 business day",
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.ARTA_METHOD_PARCEL_TRANSPORT_TYPE.SECOND_DAY_AIR]: "Delivers in 2 business days"
};
var ARTA_METHOD_DESCRIPTION = {
  SELECT: {
    WITH_ADDITIONAL_SERVICES: "Includes freight shipping, unpacking, in-home placement, and debris removal",
    WITHOUT_ADDITIONAL_SERVICES: "Includes freight shipping and scheduled delivery to outside of the home."
  }
};
var FREIGHT_CLUB_METHOD_DESCRIPTION = {
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.FREIGHT_CLUB_METHOD.GROUND]: "",
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.FREIGHT_CLUB_METHOD.THRESHOLD]: "Includes freight shipping and scheduled delivery to inside of the home.",
  [MANAGED_FLX_CUSTOM_FIELDS_VALUES.FREIGHT_CLUB_METHOD.WHITE_GLOVE_LIGHT_ASSEMBLY]: "Includes freight shipping, unpacking, in-home placement, and debris removal."
};
var FLX_UNIT_TO_ARTA_UNITS = {
  centimeter: "cm",
  inch: "in",
  kilogram: "kg",
  pound: "lb"
};
var FLX_UNIT_TO_FREIGHT_CLUB_UNITS = {
  centimeter: "CM",
  inch: "Inch",
  kilogram: "KG",
  pound: "LB"
};
var FLX_WEIGHT_UNIT_NAMES = ["kilogram", "pound"];
var FLX_DIMENSION_UNIT_NAMES = ["centimeter", "inch"];
var CUSTOM_CONTENT = {
  ABOVE_THE_FOLD: "aboveTheFold",
  CUSTOM_PRODUCT_HEADLINE: "customProductHeadline",
  CUSTOM_PRODUCT_DESCRIPTION: "customProductDescription",
  CUSTOM_DIMENSIONS: "customDimensions",
  ASK_EXPERT_COPY: "askExpertCopy",
  ASK_EXPERT: "askExpert",
  ACCORDION_SHIPPING: "accordionShipping",
  ACCORDION_CARE: "accordionCare",
  ACCORDION_DETAILS: "accordionDetails"
};
var AVAILABILITY_LABEL = {
  READY_TO_SHIP: "Ready to ship",
  OUT_OF_STOCK: "Currently unavailable",
  MADE_TO_ORDER: "Estimated Production Time"
};
var LEAD_TIME_MAX_ORDERABLE_QTY = 999;
var ORDER_ID_PREFIX = "A101";
var FLX_LISTING_URL = "https://app.flxpoint.com/listings/";
var SHIPPING_CARRIERS = {
  VOS: "VOS",
  ARTA: "ARTA",
  FREIGHT_CLUB: "FREIGHT_CLUB"
};
var SHIPPING_CARRIER_FIELD_VALUES = Object.keys(SHIPPING_CARRIERS);

// src/price.ts
var CURRENCY_ISO_CODES = {
  USD: "USD",
  CAD: "CAD",
  GBP: "GBP",
  EUR: "EUR"
};
var locales = {
  [CURRENCY_ISO_CODES.USD]: "en-US",
  [CURRENCY_ISO_CODES.EUR]: "de-DE",
  [CURRENCY_ISO_CODES.GBP]: "en-GB",
  [CURRENCY_ISO_CODES.CAD]: "en-US"
};
var formatPrice = ({
  price,
  currency = CURRENCY_ISO_CODES.USD,
  roundToInteger = false
}) => {
  const hasDecimals = price % 1 !== 0;
  return new Intl.NumberFormat(locales[currency], {
    style: "currency",
    currency,
    ...roundToInteger ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } : { minimumFractionDigits: hasDecimals ? 2 : 0 }
  }).format(price);
};

// src/states.ts
var STATES = [
  {
    shortCode: "US-AK",
    title: "Alaska"
  },
  {
    shortCode: "US-AL",
    title: "Alabama"
  },
  {
    shortCode: "US-AZ",
    title: "Arizona"
  },
  {
    shortCode: "US-AR",
    title: "Arkansas"
  },
  {
    shortCode: "US-CA",
    title: "California"
  },
  {
    shortCode: "US-CO",
    title: "Colorado"
  },
  {
    shortCode: "US-CT",
    title: "Connecticut"
  },
  {
    shortCode: "US-DE",
    title: "Delaware"
  },
  {
    shortCode: "US-FL",
    title: "Florida"
  },
  {
    shortCode: "US-GA",
    title: "Georgia"
  },
  {
    shortCode: "US-HI",
    title: "Hawaii"
  },
  {
    shortCode: "US-ID",
    title: "Idaho"
  },
  {
    shortCode: "US-IL",
    title: "Illinois"
  },
  {
    shortCode: "US-IN",
    title: "Indiana"
  },
  {
    shortCode: "US-IA",
    title: "Iowa"
  },
  {
    shortCode: "US-KS",
    title: "Kansas"
  },
  {
    shortCode: "US-KY",
    title: "Kentucky"
  },
  {
    shortCode: "US-LA",
    title: "Louisiana"
  },
  {
    shortCode: "US-ME",
    title: "Maine"
  },
  {
    shortCode: "US-MD",
    title: "Maryland"
  },
  {
    shortCode: "US-MA",
    title: "Massachusetts"
  },
  {
    shortCode: "US-MI",
    title: "Michigan"
  },
  {
    shortCode: "US-MN",
    title: "Minnesota"
  },
  {
    shortCode: "US-MS",
    title: "Mississippi"
  },
  {
    shortCode: "US-MO",
    title: "Missouri"
  },
  {
    shortCode: "US-MT",
    title: "Montana"
  },
  {
    shortCode: "US-NE",
    title: "Nebraska"
  },
  {
    shortCode: "US-NV",
    title: "Nevada"
  },
  {
    shortCode: "US-NH",
    title: "New Hampshire"
  },
  {
    shortCode: "US-NJ",
    title: "New Jersey"
  },
  {
    shortCode: "US-NM",
    title: "New Mexico"
  },
  {
    shortCode: "US-NY",
    title: "New York"
  },
  {
    shortCode: "US-NC",
    title: "North Carolina"
  },
  {
    shortCode: "US-ND",
    title: "North Dakota"
  },
  {
    shortCode: "US-OH",
    title: "Ohio"
  },
  {
    shortCode: "US-OK",
    title: "Oklahoma"
  },
  {
    shortCode: "US-OR",
    title: "Oregon"
  },
  {
    shortCode: "US-PA",
    title: "Pennsylvania"
  },
  {
    shortCode: "US-RI",
    title: "Rhode Island"
  },
  {
    shortCode: "US-SC",
    title: "South Carolina"
  },
  {
    shortCode: "US-SD",
    title: "South Dakota"
  },
  {
    shortCode: "US-TN",
    title: "Tennessee"
  },
  {
    shortCode: "US-TX",
    title: "Texas"
  },
  {
    shortCode: "US-UT",
    title: "Utah"
  },
  {
    shortCode: "US-VT",
    title: "Vermont"
  },
  {
    shortCode: "US-VA",
    title: "Virginia"
  },
  {
    shortCode: "US-WA",
    title: "Washington"
  },
  {
    shortCode: "US-WV",
    title: "West Virginia"
  },
  {
    shortCode: "US-WI",
    title: "Wisconsin"
  },
  {
    shortCode: "US-WY",
    title: "Wyoming"
  },
  {
    shortCode: "US-DC",
    title: "District of Columbia"
  }
];
var TRADE_LICENSE_DISABLED_STATES_SHORT_CODES = [
  "US-AK",
  "US-DE",
  "US-MT",
  "US-NH",
  "US-OR"
];

// src/countries.ts
var COUNTRIES = [
  {
    title: "Afghanistan",
    isoCode: "af"
  },
  {
    title: "\xC5land Islands",
    isoCode: "ax"
  },
  {
    title: "Albania",
    isoCode: "al"
  },
  {
    title: "Algeria",
    isoCode: "dz"
  },
  {
    title: "American Samoa",
    isoCode: "as"
  },
  {
    title: "Andorra",
    isoCode: "ad"
  },
  {
    title: "Angola",
    isoCode: "ao"
  },
  {
    title: "Anguilla",
    isoCode: "ai"
  },
  {
    title: "Antarctica",
    isoCode: "aq"
  },
  {
    title: "Antigua and Barbuda",
    isoCode: "ag"
  },
  {
    title: "Argentina",
    isoCode: "ar"
  },
  {
    title: "Armenia",
    isoCode: "am"
  },
  {
    title: "Aruba",
    isoCode: "aw"
  },
  {
    title: "Australia",
    isoCode: "au"
  },
  {
    title: "Austria",
    isoCode: "at"
  },
  {
    title: "Azerbaijan",
    isoCode: "az"
  },
  {
    title: "Bahamas",
    isoCode: "bs"
  },
  {
    title: "Bahrain",
    isoCode: "bh"
  },
  {
    title: "Bangladesh",
    isoCode: "bd"
  },
  {
    title: "Barbados",
    isoCode: "bb"
  },
  {
    title: "Belarus",
    isoCode: "by"
  },
  {
    title: "Belgium",
    isoCode: "be"
  },
  {
    title: "Belize",
    isoCode: "bz"
  },
  {
    title: "Benin",
    isoCode: "bj"
  },
  {
    title: "Bermuda",
    isoCode: "bm"
  },
  {
    title: "Bhutan",
    isoCode: "bt"
  },
  {
    title: "Bolivia (Plurinational State of)",
    isoCode: "bo"
  },
  {
    title: "Bonaire, Sint Eustatius and Saba",
    isoCode: "bq"
  },
  {
    title: "Bosnia and Herzegovina",
    isoCode: "ba"
  },
  {
    title: "Botswana",
    isoCode: "bw"
  },
  {
    title: "Bouvet Island",
    isoCode: "bv"
  },
  {
    title: "Brazil",
    isoCode: "br"
  },
  {
    title: "British Indian Ocean Territory",
    isoCode: "io"
  },
  {
    title: "Brunei Darussalam",
    isoCode: "bn"
  },
  {
    title: "Bulgaria",
    isoCode: "bg"
  },
  {
    title: "Burkina Faso",
    isoCode: "bf"
  },
  {
    title: "Burundi",
    isoCode: "bi"
  },
  {
    title: "Cabo Verde",
    isoCode: "cv"
  },
  {
    title: "Cambodia",
    isoCode: "kh"
  },
  {
    title: "Cameroon",
    isoCode: "cm"
  },
  {
    title: "Canada",
    isoCode: "ca"
  },
  {
    title: "Cayman Islands",
    isoCode: "ky"
  },
  {
    title: "Central African Republic",
    isoCode: "cf"
  },
  {
    title: "Chad",
    isoCode: "td"
  },
  {
    title: "Chile",
    isoCode: "cl"
  },
  {
    title: "China",
    isoCode: "cn"
  },
  {
    title: "Christmas Island",
    isoCode: "cx"
  },
  {
    title: "Cocos (Keeling) Islands",
    isoCode: "cc"
  },
  {
    title: "Colombia",
    isoCode: "co"
  },
  {
    title: "Comoros",
    isoCode: "km"
  },
  {
    title: "Congo",
    isoCode: "cg"
  },
  {
    title: "Congo, Democratic Republic of the",
    isoCode: "cd"
  },
  {
    title: "Cook Islands",
    isoCode: "ck"
  },
  {
    title: "Costa Rica",
    isoCode: "cr"
  },
  {
    title: "C\xF4te d'Ivoire",
    isoCode: "ci"
  },
  {
    title: "Croatia",
    isoCode: "hr"
  },
  {
    title: "Cuba",
    isoCode: "cu"
  },
  {
    title: "Cura\xE7ao",
    isoCode: "cw"
  },
  {
    title: "Cyprus",
    isoCode: "cy"
  },
  {
    title: "Czechia",
    isoCode: "cz"
  },
  {
    title: "Denmark",
    isoCode: "dk"
  },
  {
    title: "Djibouti",
    isoCode: "dj"
  },
  {
    title: "Dominica",
    isoCode: "dm"
  },
  {
    title: "Dominican Republic",
    isoCode: "do"
  },
  {
    title: "Ecuador",
    isoCode: "ec"
  },
  {
    title: "Egypt",
    isoCode: "eg"
  },
  {
    title: "El Salvador",
    isoCode: "sv"
  },
  {
    title: "Equatorial Guinea",
    isoCode: "gq"
  },
  {
    title: "Eritrea",
    isoCode: "er"
  },
  {
    title: "Estonia",
    isoCode: "ee"
  },
  {
    title: "Eswatini",
    isoCode: "sz"
  },
  {
    title: "Ethiopia",
    isoCode: "et"
  },
  {
    title: "Falkland Islands (Malvinas)",
    isoCode: "fk"
  },
  {
    title: "Faroe Islands",
    isoCode: "fo"
  },
  {
    title: "Fiji",
    isoCode: "fj"
  },
  {
    title: "Finland",
    isoCode: "fi"
  },
  {
    title: "France",
    isoCode: "fr"
  },
  {
    title: "French Guiana",
    isoCode: "gf"
  },
  {
    title: "French Polynesia",
    isoCode: "pf"
  },
  {
    title: "French Southern Territories",
    isoCode: "tf"
  },
  {
    title: "Gabon",
    isoCode: "ga"
  },
  {
    title: "Gambia",
    isoCode: "gm"
  },
  {
    title: "Georgia",
    isoCode: "ge"
  },
  {
    title: "Germany",
    isoCode: "de"
  },
  {
    title: "Ghana",
    isoCode: "gh"
  },
  {
    title: "Gibraltar",
    isoCode: "gi"
  },
  {
    title: "Greece",
    isoCode: "gr"
  },
  {
    title: "Greenland",
    isoCode: "gl"
  },
  {
    title: "Grenada",
    isoCode: "gd"
  },
  {
    title: "Guadeloupe",
    isoCode: "gp"
  },
  {
    title: "Guam",
    isoCode: "gu"
  },
  {
    title: "Guatemala",
    isoCode: "gt"
  },
  {
    title: "Guernsey",
    isoCode: "gg"
  },
  {
    title: "Guinea",
    isoCode: "gn"
  },
  {
    title: "Guinea-Bissau",
    isoCode: "gw"
  },
  {
    title: "Guyana",
    isoCode: "gy"
  },
  {
    title: "Haiti",
    isoCode: "ht"
  },
  {
    title: "Heard Island and McDonald Islands",
    isoCode: "hm"
  },
  {
    title: "Holy See",
    isoCode: "va"
  },
  {
    title: "Honduras",
    isoCode: "hn"
  },
  {
    title: "Hong Kong",
    isoCode: "hk"
  },
  {
    title: "Hungary",
    isoCode: "hu"
  },
  {
    title: "Iceland",
    isoCode: "is"
  },
  {
    title: "India",
    isoCode: "in"
  },
  {
    title: "Indonesia",
    isoCode: "id"
  },
  {
    title: "Iran (Islamic Republic of)",
    isoCode: "ir"
  },
  {
    title: "Iraq",
    isoCode: "iq"
  },
  {
    title: "Ireland",
    isoCode: "ie"
  },
  {
    title: "Isle of Man",
    isoCode: "im"
  },
  {
    title: "Israel",
    isoCode: "il"
  },
  {
    title: "Italy",
    isoCode: "it"
  },
  {
    title: "Jamaica",
    isoCode: "jm"
  },
  {
    title: "Japan",
    isoCode: "jp"
  },
  {
    title: "Jersey",
    isoCode: "je"
  },
  {
    title: "Jordan",
    isoCode: "jo"
  },
  {
    title: "Kazakhstan",
    isoCode: "kz"
  },
  {
    title: "Kenya",
    isoCode: "ke"
  },
  {
    title: "Kiribati",
    isoCode: "ki"
  },
  {
    title: "Korea (Democratic People's Republic of)",
    isoCode: "kp"
  },
  {
    title: "Korea, Republic of",
    isoCode: "kr"
  },
  {
    title: "Kuwait",
    isoCode: "kw"
  },
  {
    title: "Kyrgyzstan",
    isoCode: "kg"
  },
  {
    title: "Lao People's Democratic Republic",
    isoCode: "la"
  },
  {
    title: "Latvia",
    isoCode: "lv"
  },
  {
    title: "Lebanon",
    isoCode: "lb"
  },
  {
    title: "Lesotho",
    isoCode: "ls"
  },
  {
    title: "Liberia",
    isoCode: "lr"
  },
  {
    title: "Libya",
    isoCode: "ly"
  },
  {
    title: "Liechtenstein",
    isoCode: "li"
  },
  {
    title: "Lithuania",
    isoCode: "lt"
  },
  {
    title: "Luxembourg",
    isoCode: "lu"
  },
  {
    title: "Macao",
    isoCode: "mo"
  },
  {
    title: "Madagascar",
    isoCode: "mg"
  },
  {
    title: "Malawi",
    isoCode: "mw"
  },
  {
    title: "Malaysia",
    isoCode: "my"
  },
  {
    title: "Maldives",
    isoCode: "mv"
  },
  {
    title: "Mali",
    isoCode: "ml"
  },
  {
    title: "Malta",
    isoCode: "mt"
  },
  {
    title: "Marshall Islands",
    isoCode: "mh"
  },
  {
    title: "Martinique",
    isoCode: "mq"
  },
  {
    title: "Mauritania",
    isoCode: "mr"
  },
  {
    title: "Mauritius",
    isoCode: "mu"
  },
  {
    title: "Mayotte",
    isoCode: "yt"
  },
  {
    title: "Mexico",
    isoCode: "mx"
  },
  {
    title: "Micronesia (Federated States of)",
    isoCode: "fm"
  },
  {
    title: "Moldova, Republic of",
    isoCode: "md"
  },
  {
    title: "Monaco",
    isoCode: "mc"
  },
  {
    title: "Mongolia",
    isoCode: "mn"
  },
  {
    title: "Montenegro",
    isoCode: "me"
  },
  {
    title: "Montserrat",
    isoCode: "ms"
  },
  {
    title: "Morocco",
    isoCode: "ma"
  },
  {
    title: "Mozambique",
    isoCode: "mz"
  },
  {
    title: "Myanmar",
    isoCode: "mm"
  },
  {
    title: "Namibia",
    isoCode: "na"
  },
  {
    title: "Nauru",
    isoCode: "nr"
  },
  {
    title: "Nepal",
    isoCode: "np"
  },
  {
    title: "Netherlands",
    isoCode: "nl"
  },
  {
    title: "New Caledonia",
    isoCode: "nc"
  },
  {
    title: "New Zealand",
    isoCode: "nz"
  },
  {
    title: "Nicaragua",
    isoCode: "ni"
  },
  {
    title: "Niger",
    isoCode: "ne"
  },
  {
    title: "Nigeria",
    isoCode: "ng"
  },
  {
    title: "Niue",
    isoCode: "nu"
  },
  {
    title: "Norfolk Island",
    isoCode: "nf"
  },
  {
    title: "North Macedonia",
    isoCode: "mk"
  },
  {
    title: "Northern Mariana Islands",
    isoCode: "mp"
  },
  {
    title: "Norway",
    isoCode: "no"
  },
  {
    title: "Oman",
    isoCode: "om"
  },
  {
    title: "Pakistan",
    isoCode: "pk"
  },
  {
    title: "Palau",
    isoCode: "pw"
  },
  {
    title: "Palestine, State of",
    isoCode: "ps"
  },
  {
    title: "Panama",
    isoCode: "pa"
  },
  {
    title: "Papua New Guinea",
    isoCode: "pg"
  },
  {
    title: "Paraguay",
    isoCode: "py"
  },
  {
    title: "Peru",
    isoCode: "pe"
  },
  {
    title: "Philippines",
    isoCode: "ph"
  },
  {
    title: "Pitcairn",
    isoCode: "pn"
  },
  {
    title: "Poland",
    isoCode: "pl"
  },
  {
    title: "Portugal",
    isoCode: "pt"
  },
  {
    title: "Puerto Rico",
    isoCode: "pr"
  },
  {
    title: "Qatar",
    isoCode: "qa"
  },
  {
    title: "R\xE9union",
    isoCode: "re"
  },
  {
    title: "Romania",
    isoCode: "ro"
  },
  {
    title: "Russian Federation",
    isoCode: "ru"
  },
  {
    title: "Rwanda",
    isoCode: "rw"
  },
  {
    title: "Saint Barth\xE9lemy",
    isoCode: "bl"
  },
  {
    title: "Saint Helena, Ascension and Tristan da Cunha",
    isoCode: "sh"
  },
  {
    title: "Saint Kitts and Nevis",
    isoCode: "kn"
  },
  {
    title: "Saint Lucia",
    isoCode: "lc"
  },
  {
    title: "Saint Martin (French part)",
    isoCode: "mf"
  },
  {
    title: "Saint Pierre and Miquelon",
    isoCode: "pm"
  },
  {
    title: "Saint Vincent and the Grenadines",
    isoCode: "vc"
  },
  {
    title: "Samoa",
    isoCode: "ws"
  },
  {
    title: "San Marino",
    isoCode: "sm"
  },
  {
    title: "Sao Tome and Principe",
    isoCode: "st"
  },
  {
    title: "Saudi Arabia",
    isoCode: "sa"
  },
  {
    title: "Senegal",
    isoCode: "sn"
  },
  {
    title: "Serbia",
    isoCode: "rs"
  },
  {
    title: "Seychelles",
    isoCode: "sc"
  },
  {
    title: "Sierra Leone",
    isoCode: "sl"
  },
  {
    title: "Singapore",
    isoCode: "sg"
  },
  {
    title: "Sint Maarten (Dutch part)",
    isoCode: "sx"
  },
  {
    title: "Slovakia",
    isoCode: "sk"
  },
  {
    title: "Slovenia",
    isoCode: "si"
  },
  {
    title: "Solomon Islands",
    isoCode: "sb"
  },
  {
    title: "Somalia",
    isoCode: "so"
  },
  {
    title: "South Africa",
    isoCode: "za"
  },
  {
    title: "South Georgia and the South Sandwich Islands",
    isoCode: "gs"
  },
  {
    title: "South Sudan",
    isoCode: "ss"
  },
  {
    title: "Spain",
    isoCode: "es"
  },
  {
    title: "Sri Lanka",
    isoCode: "lk"
  },
  {
    title: "Sudan",
    isoCode: "sd"
  },
  {
    title: "Suriname",
    isoCode: "sr"
  },
  {
    title: "Svalbard and Jan Mayen",
    isoCode: "sj"
  },
  {
    title: "Sweden",
    isoCode: "se"
  },
  {
    title: "Switzerland",
    isoCode: "ch"
  },
  {
    title: "Syrian Arab Republic",
    isoCode: "sy"
  },
  {
    title: "Taiwan, Province of China",
    isoCode: "tw"
  },
  {
    title: "Tajikistan",
    isoCode: "tj"
  },
  {
    title: "Tanzania, United Republic of",
    isoCode: "tz"
  },
  {
    title: "Thailand",
    isoCode: "th"
  },
  {
    title: "Timor-Leste",
    isoCode: "tl"
  },
  {
    title: "Togo",
    isoCode: "tg"
  },
  {
    title: "Tokelau",
    isoCode: "tk"
  },
  {
    title: "Tonga",
    isoCode: "to"
  },
  {
    title: "Trinidad and Tobago",
    isoCode: "tt"
  },
  {
    title: "Tunisia",
    isoCode: "tn"
  },
  {
    title: "Turkey",
    isoCode: "tr"
  },
  {
    title: "Turkmenistan",
    isoCode: "tm"
  },
  {
    title: "Turks and Caicos Islands",
    isoCode: "tc"
  },
  {
    title: "Tuvalu",
    isoCode: "tv"
  },
  {
    title: "Uganda",
    isoCode: "ug"
  },
  {
    title: "Ukraine",
    isoCode: "ua"
  },
  {
    title: "United Arab Emirates",
    isoCode: "ae"
  },
  {
    title: "United Kingdom",
    isoCode: "gb"
  },
  {
    title: "United States",
    isoCode: "us"
  },
  {
    title: "United States Minor Outlying Islands",
    isoCode: "um"
  },
  {
    title: "Uruguay",
    isoCode: "uy"
  },
  {
    title: "Uzbekistan",
    isoCode: "uz"
  },
  {
    title: "Vanuatu",
    isoCode: "vu"
  },
  {
    title: "Venezuela (Bolivarian Republic of)",
    isoCode: "ve"
  },
  {
    title: "Viet Nam",
    isoCode: "vn"
  },
  {
    title: "Virgin Islands (British)",
    isoCode: "vg"
  },
  {
    title: "Virgin Islands (U.S.)",
    isoCode: "vi"
  },
  {
    title: "Wallis and Futuna",
    isoCode: "wf"
  },
  {
    title: "Western Sahara",
    isoCode: "eh"
  },
  {
    title: "Yemen",
    isoCode: "ye"
  },
  {
    title: "Zambia",
    isoCode: "zm"
  },
  {
    title: "Zimbabwe",
    isoCode: "zw"
  }
];

// src/common.ts
import { ReactQuery } from "cms-api";
var EXPERT_USER_CAPABILITIES = {
  CONSULTATION: "CONSULTATION",
  MAIN: "MAIN",
  TRADE: "TRADE"
};
var CMS_EXPERT_PAGE_SLUGS = {
  SHOWROOM: (expertId) => `experts/${expertId}/showroom`
};
var EXPERT_DETAIL_TAB_KEYS = {
  SHOWROOM: "SHOWROOM",
  CONSULTATION: "CONSULTATION"
};
var CART_ADDRESS_KEYS = [
  "email",
  "phone",
  "fullName",
  "addressLine1",
  "addressLine2",
  "countryIsoCode",
  "countryState",
  "city",
  "zipCode"
];
var ENABLED_PRIVATE_SESSION_DURATIONS_IN_MINUTES = [
  30,
  60,
  90,
  120
];
var DEFAULT_SESSION_LENGTH_IN_MINUTES = "25";
var DEFAULT_PAGINATION_LIMIT = 20;
var COLLECTION_STATUSES = {
  PUBLISHED: "PUBLISHED",
  NOT_PUBLISHED: "NOT_PUBLISHED",
  IN_REVIEW: "IN_REVIEW"
};
var FEATURE_FLAGS = {
  PAYMENT: "PAYMENT",
  USER_SELF_SERVICE_SHOWROOM: "USER_SELF_SERVICE_SHOWROOM",
  EXPERT_COMMISSIONS: "EXPERT_COMMISSIONS"
};
var EXPERT_COLLECTION_MIN_REQUIRED_PRODUCTS = 32;
var SESSION_SUBSCRIPTION_DATE_RANGE = {
  NEXT_MONTH: "NEXT_MONTH",
  NEXT_SIX_MONTHS: "NEXT_SIX_MONTHS",
  THIS_WEEK: "THIS_WEEK",
  NEXT_TWO_WEEKS: "NEXT_TWO_WEEKS"
};
var SESSION_SUBSCRIPTION_TIME_RANGE = {
  MORNING: "MORNING",
  AFTERNOON: "AFTERNOON",
  EVENING: "EVENING"
};
var COLLECTION_SUBTYPES = {
  DEFAULT: "DEFAULT",
  EXPERT_SHOWROOM: "EXPERT_SHOWROOM"
};
var TITLE_OPTIONS = [
  {
    label: "Principal Designer / Owner",
    value: ReactQuery.TradeApplicationTitle.PRINCIPLE_DESIGNER_OWNER
  },
  {
    label: "Interior Designer / Design Assistant",
    value: ReactQuery.TradeApplicationTitle.INTERIOR_DESIGNER_DESIGN_ASSISTANT
  },
  {
    label: "Purchaser / Project Manager",
    value: ReactQuery.TradeApplicationTitle.PURCHASER_PROJECT_MANAGER
  },
  {
    label: "Librarian / Resource Manager",
    value: ReactQuery.TradeApplicationTitle.LIBRARIAN_RESOURCE_MANAGER
  },
  { label: "Other", value: ReactQuery.TradeApplicationTitle.OTHER }
];
var HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS = [
  {
    label: "Instagram/Facebook Ad",
    value: "INSTAGRAM_FACEBOOK"
  },
  {
    label: "Google",
    value: "GOOGLE"
  },
  {
    label: "Friend (Word of mouth)",
    value: "FRIEND"
  },
  {
    label: "Press",
    value: "PRESS"
  },
  {
    label: "Pinterest",
    value: "PINTEREST"
  },
  {
    label: "A designer on The Expert",
    value: "DESIGNER_ON_THE_EXPERT"
  },
  {
    label: "The Expert\u2019s Instagram page",
    value: "EXPERT_INSTAGRAM_PAGE"
  },
  { label: "Other", value: "OTHER" }
];
var TRADE_APPLICATION_SURVEY = {
  designSpeciality: {
    question: "What\u2019s your Design Specialty:",
    answers: [
      "Residential",
      "Commercial",
      "Decorating",
      "Staging",
      "Architecture",
      "Hospitality",
      "Other"
    ]
  },
  projectsCount: {
    question: "How many projects does your team work on at a time?",
    answers: ["1-5", "6-10", "10+"]
  },
  whatBringsYouToTheSite: {
    question: "What brings you to the site?",
    answers: [
      "Just browsing",
      "Sourcing / getting quotes",
      "Actively purchasing"
    ]
  },
  teamSize: {
    question: "How large is your team?",
    answers: ["1-4", "5-10", "11-15", "16-20", "20+"]
  },
  howDidYouHearAboutUs: {
    question: "How did you hear about us?"
  }
};

// src/expertFeatures.ts
var EXPERT_FEATURES = {
  EXPERT_DASHBOARD: {
    HOME: "HOME",
    SCHEDULE: "SCHEDULE",
    CONSULTATIONS: "CONSULTATIONS",
    CONSULTATIONS_TEAM_INFO: "CONSULTATIONS_TEAM_INFO",
    CLIENTS: "CLIENTS",
    COMMISSIONS: "COMMISSIONS",
    TEAM: "TEAM",
    EXPERT_PROFILE: {
      GENERAL: "GENERAL",
      SHOWROOM: "SHOWROOM"
    },
    PAYMENT: {
      OVERVIEW: "OVERVIEW",
      TAX_DOCUMENTS: "TAX_DOCUMENTS"
    },
    EXPERT_ACCOUNT: {
      BUSINESS_NAME: "BUSINESS_NAME",
      NOTIFICATION_EMAILS: "NOTIFICATION_EMAILS",
      TIMEZONE: "TIMEZONE",
      ZOOM: "ZOOM",
      CALENDAR: "CALENDAR",
      DESIGNER_AGREEMENTS: "DESIGNER_AGREEMENTS"
    },
    PREVIEW_EXPERT_PROFILE: "PREVIEW_EXPERT_PROFILE",
    REFERRAL_PROGRAM: "REFERRAL_PROGRAM"
  },
  PRODUCT_DETAIL_PAGE: {
    ADD_TO_SHOWROOM: "ADD_TO_SHOWROOM"
  },
  ADMIN_EXPERT_DETAIL: {
    EXPERT_INFO: {
      PROFILE_NAME: "PROFILE_NAME",
      SLUG: "SLUG",
      REGIONS: "REGIONS",
      TAGS: "TAGS",
      ADDRESS: "ADDRESS",
      TIMEZONE: "TIMEZONE",
      CURRENCY: "CURRENCY",
      FEATURED: "FEATURED",
      FUNDRAISER: "FUNDRAISER",
      STRIPE: "STRIPE",
      IS_FINDABLE: "IS_FINDABLE",
      IS_SEARCHABLE: "IS_SEARCHABLE",
      SUBSCRIBERS: "SUBSCRIBERS"
    },
    EXPERT_USERS: {
      DISCONNECT_ZOOM: "DISCONNECT_ZOOM",
      TIMEZONE: "TIMEZONE",
      PROFILE_IMAGE_URL: "PROFILE_IMAGE_URL",
      ZOOM: "ZOOM",
      BOOKINGS_COUNT: "BOOKINGS_COUNT",
      ACTIVE_SESSIONS_COUNT: "ACTIVE_SESSIONS_COUNT",
      TOTAL_EARNED: "TOTAL_EARNED",
      AVAILABILITY_HOURS: "AVAILABILITY_HOURS",
      ZOOM_ACCOUNT_TYPE: "ZOOM_ACCOUNT_TYPE"
    },
    EXPERT_ACTIONS: {
      WARN: "WARN",
      BAN: "BAN",
      PROFILE_LISTED: "PROFILE_LISTED",
      SEARCHABILITY: "SEARCHABILITY",
      STRIPE_DISCONNECT: "STRIPE_DISCONNECT"
    },
    EXPERT_TABS: {
      ACCOUNT: "ACCOUNT",
      SOCIAL: "SOCIAL",
      USERS: "USERS",
      TESTIMONIALS: "TESTIMONIALS",
      REVIEWS: "REVIEWS",
      CANCELATION_POLICY: "CANCELATION_POLICY",
      FEATURE_FLAGS: "FEATURE_FLAGS",
      BUSINESS_NAME: "BUSINESS_NAME",
      PLATFORM_FEE: "PLATFORM_FEE"
    }
  }
};
var EXPERT_FEATURES_DEFINITION = /* @__PURE__ */ new Map([
  // Expert dashboard section
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.HOME,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.REFERRAL_PROGRAM,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.SCHEDULE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.CONSULTATIONS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.CLIENTS,
    {
      requiredCapabilities: [
        EXPERT_USER_CAPABILITIES.MAIN,
        EXPERT_USER_CAPABILITIES.CONSULTATION
      ],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.COMMISSIONS,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: [FEATURE_FLAGS.EXPERT_COMMISSIONS]
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.TEAM,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.MAIN],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.CONSULTATIONS_TEAM_INFO,
    {
      requiredCapabilities: [
        EXPERT_USER_CAPABILITIES.MAIN,
        EXPERT_USER_CAPABILITIES.CONSULTATION
      ],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.EXPERT_PROFILE.GENERAL,
    {
      requiredCapabilities: [
        EXPERT_USER_CAPABILITIES.MAIN,
        EXPERT_USER_CAPABILITIES.CONSULTATION
      ],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.EXPERT_PROFILE.SHOWROOM,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.MAIN],
      requiredFeatureFlags: [FEATURE_FLAGS.USER_SELF_SERVICE_SHOWROOM]
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.PAYMENT.OVERVIEW,
    {
      requiredCapabilities: [
        EXPERT_USER_CAPABILITIES.MAIN,
        EXPERT_USER_CAPABILITIES.CONSULTATION
      ],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.PAYMENT.TAX_DOCUMENTS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.TRADE],
      requiredFeatureFlags: []
    }
  ],
  // Expert dashboard expert account section
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.EXPERT_ACCOUNT,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.EXPERT_ACCOUNT.BUSINESS_NAME,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.MAIN],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.EXPERT_ACCOUNT.NOTIFICATION_EMAILS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.EXPERT_ACCOUNT.TIMEZONE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.EXPERT_ACCOUNT.ZOOM,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.EXPERT_ACCOUNT.CALENDAR,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.EXPERT_ACCOUNT.DESIGNER_AGREEMENTS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.EXPERT_DASHBOARD.PREVIEW_EXPERT_PROFILE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  // Admin expert detail expert info section
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.PROFILE_NAME,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.SLUG,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.REGIONS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.TAGS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.ADDRESS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.TIMEZONE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.CURRENCY,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.FEATURED,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.FUNDRAISER,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.STRIPE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.IS_FINDABLE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.IS_SEARCHABLE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_INFO.SUBSCRIBERS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS.DISCONNECT_ZOOM,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS.TIMEZONE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS.PROFILE_IMAGE_URL,
    {
      requiredCapabilities: [
        EXPERT_USER_CAPABILITIES.CONSULTATION,
        EXPERT_USER_CAPABILITIES.MAIN
      ],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS.ZOOM,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS.BOOKINGS_COUNT,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS.ACTIVE_SESSIONS_COUNT,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS.TOTAL_EARNED,
    {
      requiredCapabilities: [
        EXPERT_USER_CAPABILITIES.CONSULTATION,
        EXPERT_USER_CAPABILITIES.MAIN
      ],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS.AVAILABILITY_HOURS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_USERS.ZOOM_ACCOUNT_TYPE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  // Admin expert detail expert actions section
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_ACTIONS,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_ACTIONS.WARN,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_ACTIONS.BAN,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_ACTIONS.PROFILE_LISTED,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_ACTIONS.SEARCHABILITY,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_ACTIONS.STRIPE_DISCONNECT,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  // Admin expert detail expert tabs section
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS.ACCOUNT,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS.SOCIAL,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS.USERS,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS.TESTIMONIALS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS.REVIEWS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS.CANCELATION_POLICY,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS.FEATURE_FLAGS,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS.BUSINESS_NAME,
    {
      requiredCapabilities: [],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.ADMIN_EXPERT_DETAIL.EXPERT_TABS.PLATFORM_FEE,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.CONSULTATION],
      requiredFeatureFlags: []
    }
  ],
  [
    EXPERT_FEATURES.PRODUCT_DETAIL_PAGE.ADD_TO_SHOWROOM,
    {
      requiredCapabilities: [EXPERT_USER_CAPABILITIES.MAIN],
      requiredFeatureFlags: [FEATURE_FLAGS.USER_SELF_SERVICE_SHOWROOM]
    }
  ]
]);
export {
  ARTA_METHOD_ALIASES,
  ARTA_METHOD_DESCRIPTION,
  ARTA_METHOD_PARCEL_TRANSPORT_ESTIMATES,
  AVAILABILITY_LABEL,
  CART_ADDRESS_KEYS,
  CMS_EXPERT_PAGE_SLUGS,
  COLLECTION_STATUSES,
  COLLECTION_SUBTYPES,
  COUNTRIES,
  CURRENCY_ISO_CODES,
  CUSTOM_CONTENT,
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_SESSION_LENGTH_IN_MINUTES,
  DEPRECATED_TIMEZONES,
  DEPRECATED_TIMEZONES_MAPPING,
  DYNAMIC_ROUTE,
  EMAILS,
  ENABLED_PRIVATE_SESSION_DURATIONS_IN_MINUTES,
  EXPERT_COLLECTION_MIN_REQUIRED_PRODUCTS,
  EXPERT_DETAIL_TAB_KEYS,
  EXPERT_FEATURES,
  EXPERT_FEATURES_DEFINITION,
  EXPERT_USER_CAPABILITIES,
  FEATURE_FLAGS,
  FLX_DIMENSION_UNIT_NAMES,
  FLX_KEY_PREFIX,
  FLX_LISTING_URL,
  FLX_UNIT_TO_ARTA_UNITS,
  FLX_UNIT_TO_FREIGHT_CLUB_UNITS,
  FLX_WEIGHT_UNIT_NAMES,
  FREIGHT_CLUB_METHOD_DESCRIPTION,
  FREIGHT_METHOD_ALIASES,
  HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS,
  LEAD_TIME_MAX_ORDERABLE_QTY,
  MANAGED_ARTA_CUSTOM_FIELDS,
  MANAGED_FLX_CUSTOM_CONTENT,
  MANAGED_FLX_CUSTOM_FIELDS,
  MANAGED_FLX_CUSTOM_FIELDS_VALUES,
  MANAGED_FLX_VARIANT_CUSTOM_FIELDS,
  ORDER_ID_PREFIX,
  PUBLIC_ROUTE,
  RECAPTCHA_ROUTES,
  REVALIDATE_ROUTE,
  REVENUE_AREA,
  ROUTE,
  SESSION_SUBSCRIPTION_DATE_RANGE,
  SESSION_SUBSCRIPTION_TIME_RANGE,
  SHIPPING_CARRIERS,
  SHIPPING_CARRIER_FIELD_VALUES,
  SIGN_IN_EXPERT_TRADE_ROUTES,
  STATES,
  TITLE_OPTIONS,
  TRADE_APPLICATION_SURVEY,
  TRADE_LICENSE_DISABLED_STATES_SHORT_CODES,
  VENDOR_SHIPPING_NAME,
  additionalTimezones,
  formatPrice,
  formatTimezoneToString,
  mapCustomizedTimezoneToTimezone,
  mapTimezoneToCustomizedTimezone,
  withSearchParams
};
//# sourceMappingURL=index.mjs.map